/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_Not_ConnectedInputs */

const cs_xml_feed_not_connected = /** @type {(inputs: Xml_Feed_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím nenastaveno`)
};

const en_xml_feed_not_connected = /** @type {(inputs: Xml_Feed_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not set up`)
};

/**
* | output |
* | --- |
* | "Not set up" |
*
* @param {Xml_Feed_Not_ConnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_not_connected = /** @type {((inputs?: Xml_Feed_Not_ConnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_Not_ConnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_not_connected(inputs)
	return cs_xml_feed_not_connected(inputs)
});